import { render, staticRenderFns } from "./AttachmentPreviewByType.vue?vue&type=template&id=08af760e&scoped=true"
import script from "./AttachmentPreviewByType.vue?vue&type=script&lang=js"
export * from "./AttachmentPreviewByType.vue?vue&type=script&lang=js"
import style0 from "./AttachmentPreviewByType.vue?vue&type=style&index=0&id=08af760e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08af760e",
  null
  
)

export default component.exports